import { DateTime } from 'luxon';

export default class DateService {
  static getReadableDate(dateOrDateTime: string): string {
    const dateTime = DateTime.fromISO(dateOrDateTime);
    return dateTime.toFormat('dd.MM.yyyy');
  }

  static getReadableDateTime(timeOrDate: string): string {
    const dateTime = DateTime.fromISO(timeOrDate);
    return dateTime.toFormat('dd.MM.yyyy, HH:mm') + ' Uhr';
  }

  static getReadableTime(timeOrDateTime: string): string {
    const dateTime = DateTime.fromISO(timeOrDateTime);
    return dateTime.toFormat('HH:mm') + ' Uhr';
  }

  static toISOString(date: string): string {
    const dateTime = DateTime.fromISO(date);
    return dateTime.toISO();
  }

  static getReadableDateWithMonthName(dateOrDateTime: string): string {
    const dateTime = DateTime.fromISO(dateOrDateTime);
    return dateTime.toFormat('d. MMMM yyyy');
  }

  static getReadableDateTimeWithMonthName(dateOrDateTime: string): string {
    return this.getReadableDateWithMonthName(dateOrDateTime);
  }

  static getReadableDateTimeInNearPast(dateTime: string): string {
    const dateTimeValue = DateTime.fromISO(dateTime);
    const currentDateTime = DateTime.now();
    const diff = Math.floor(
      currentDateTime.diff(dateTimeValue, 'hours').as('hours')
    );

    if (dateTimeValue.hasSame(currentDateTime, 'day')) {
      if (diff < 1) {
        const minutesDiff = Math.floor(
          currentDateTime.diff(dateTimeValue, 'minutes').minutes
        );
        return ` ${minutesDiff} minutes ago`;
      } else {
        return ` ${diff} hours ago`;
      }
    } else if (
      dateTimeValue.hasSame(currentDateTime.minus({ days: 1 }), 'day')
    ) {
      return 'Yesterday';
    } else if (
      dateTimeValue.hasSame(currentDateTime.minus({ days: 2 }), 'day')
    ) {
      return '2 days ago';
    } else {
      return this.getReadableDateWithMonthName(dateTime);
    }
  }
}
